import { apiFetch } from "./client";

/** 紹介パートナー（アフィリエイト）。ref_code は `?ref=` 帰属と同じキー。 */
export interface Partner {
  ref_code: string;
  display_name: string;
}

export interface ReferrerOption {
  value: string;
  label: string;
}

/** 初回起動アンケートの「紹介元」候補（is_active のみ・表示順）を取得する。 */
export function getPartners(): Promise<{
  partners: Partner[];
  referrer_options?: Record<"blog" | "referral", ReferrerOption[]>;
}> {
  return apiFetch("/api/partners");
}
